export default {
  control: 'checkbox',
  values: [true, false],
};
